import { CurrencyCode } from 'further-types/lp/vehicle';
import { getCurrencySymbol } from 'further-ui/utils';
import { Control } from 'react-hook-form';
import ReceivedConsiderationRow from './ConsiderationRows/ReceivedConsiderationRow';
import EscrowConsiderationRow from './ConsiderationRows/EscrowConsiderationRow';
import EarnoutConsiderationRow from './ConsiderationRows/EarnoutConsiderationRow';
import WithholdingTaxConsiderationRow from './ConsiderationRows/WithholdingTaxConsiderationRow';

import { realisation as rules } from 'further-ui/validations';

type Props = {
  control: Control<rules.CreateRealisationFormValues>;
  index: number;
  currencyCode: CurrencyCode;
  disabled: boolean;
};

const ProRataConsiderationForm: React.FC<Props> = ({
  control,
  index,
  currencyCode,
  disabled,
}) => {
  const currencySymbol = getCurrencySymbol(currencyCode);

  return (
    <>
      <ReceivedConsiderationRow
        control={control}
        index={index}
        currencySymbol={currencySymbol}
        disabled={disabled}
      />
      <EscrowConsiderationRow
        control={control}
        index={index}
        currencySymbol={currencySymbol}
        disabled={disabled}
      />
      <EarnoutConsiderationRow
        control={control}
        index={index}
        currencySymbol={currencySymbol}
        disabled={disabled}
      />
      <WithholdingTaxConsiderationRow
        control={control}
        index={index}
        currencySymbol={currencySymbol}
        disabled={disabled}
      />
    </>
  );
};

export default ProRataConsiderationForm;
